<template>
    <fieldset class="tw-min-w-0 tw-space-y-6 tw-border-none">
        <slot />
    </fieldset>
</template>
